import { useEffect, useState } from "react";
import FetchData from "../../shared/fetchData";
import { checkValidity, updateObject } from "../../shared/utility";
import ContentForm from "../UI/ContentForm/ContentForm";
import Input from "../UI/Input/Input";
import Select from "../UI/Select/Select";
import Button from "../UI/Button/Button";

const EventListenerForm = (props) => {

    const [edit, setEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rerender, setRerender] = useState(false);
    const [eventListener, setEventListener] = useState({
        cellNumber: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "تلفن همراه",
            },
            validation: {
                required: true,
            },
            errorMessage: "فیلد الزامی است",
            valid: true,
            value: "",
        },
        text: {
            elementType: "textarea",
            elementConfig: {
                type: "text",
                placeholder: "متن پیامک",
            },
            validation: {
                required: true,
            },
            errorMessage: "فیلد الزامی است",
            valid: true,
            value: "",
        },
    });
    const [eventType, setEventType] = useState('');
    const [events, setEvents] = useState([]);

    useEffect(() => {
        setEdit(props.edit);
        var info = {
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/events/getActiveEvents'
        FetchData(raw, url).then(response => response.json())
            .then(evResult => {
                if (evResult.status == "0") {
                    setEvents(evResult.events);
                }
                if (props.edit != null && props.edit == true) {
                    var info = {
                        "eventListener": {
                            "id": props.eventListenerId,
                        },
                        "version": "mtpx001",
                    }
                    var raw = JSON.stringify(info)
                    var url = 'management/api/v1/eventlisteners/getEventListenerInfo'
                    FetchData(raw, url).then(response => response.json())
                        .then(result => {
                            if (result.status == "0") {
                                const evLi = eventListener;
                                evLi.cellNumber.value = result.eventListener.cellNumber;
                                evLi.text.value = result.eventListener.text;
                                setEventListener(evLi);
                                const evt = evResult.events?.filter(e => e.id === result.eventListener.eventId);
                                if (!!evt && evt.length != 0) {
                                    setEventType({
                                        value: evt[0].id,
                                        label: evt[0].typeDescription,
                                    })
                                }
                                setRerender(!rerender);
                            }
                        })
                        .catch(error => setLoading(false))
                } else {
                    const evLi = eventListener;
                    evLi.cellNumber.value = "";
                    evLi.text.value = "";
                    setEventType('');
                    setRerender(!rerender);
                }
            })
            .catch(error => setLoading(false))
    }, [props.edit]);
    const insertEventListener = (event) => {
        var info = {
            "eventListener": {
                "id": edit ? props.eventListenerId : "",
                "cellNumber": eventListener.cellNumber.value,
                "text": eventListener.text.value,
                "eventId": eventType?.value,
            },
            "version": "mtpx001",
        }
        var raw = JSON.stringify(info)
        var url = edit ? 'management/api/v1/eventlisteners/updateEventListener' : 'management/api/v1/eventlisteners/insertEventListener'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == "0") {
                    props.backToGridAndUpdate();
                }
            })
            .catch(error => setLoading(false))
    }
    const eventChange = selectedOption => {
        setEventType(selectedOption);
    }
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(eventListener, {
            [controlName]: updateObject(eventListener[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, eventListener[controlName].validation)
            })
        });
        setEventListener(updatedControls);
    }
    const formElementsArray = [];
    for (let key in eventListener) {
        formElementsArray.push({
            id: key,
            config: eventListener[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        let className = '6 mt-3'
        if (formElement.id == 'text') {
            className = '12 mt-3'
        }
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col={className}
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });
    const eventList = [];
    events?.map(e => {
        eventList.push({
            value: e.id,
            label: e.typeDescription,
        })
    })
    return (
        <div className="row justify-content-center mt-5">
            <div className="col-6">
                <ContentForm>
                    <div className="row justify-content-center p-5">
                        <Select
                            name="form-field-name"
                            value={eventType}
                            placeholder="نوع رویداد"
                            options={eventList}
                            onChange={eventChange}
                            col="6 mt-3 mb-3"
                        />
                        {form}
                        <div className="row justify-content-center p-5">
                            <div className="col-6">
                                <Button btnType="Success" clicked={insertEventListener} >ثبت</Button>
                            </div>
                            <div className="col-6">
                                <Button btnType="General" clicked={props.backToGrid} >برگشت</Button>
                            </div>
                        </div>
                    </div>
                </ContentForm>
            </div>
        </div>
    )
}

export default EventListenerForm;